import { ChangeEvent, ReactElement, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { IEAFProduction, IParentSize, IState } from "../../../types";
import { useSelector } from "react-redux";
import TabPanel from "../../../components/tabPanel";
import ProductionTable from "./productionTable";
import ProductionAlloys from "./productionAlloys";
import ProductionAlloysKPI from "./productionAlloysKPI";
import ProductionLime from "./productionLime";
import ProductionLimeKPI from "./productionLimeKPI";

interface IProps {
  productionData: IEAFProduction[];
  parentSize: IParentSize;
}

const a11yProps = (index: number): any => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};


const ProductionTab = ({ productionData, parentSize }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [tabSelected, setTabSelected] = useState(0);


  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  return (
    <>
      <Tabs
        value={tabSelected}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="Heats" {...a11yProps(0)} />
        <Tab label="Alloys" {...a11yProps(1)} />
        <Tab label="Alloys - Chart" {...a11yProps(2)} />
        <Tab label="Lime" {...a11yProps(3)} />
        <Tab label="Lime - Chart" {...a11yProps(4)} />
      </Tabs>
      <TabPanel value={tabSelected} index={0} >
        <ProductionTable productionData={productionData} parentSize={{ width: parentSize.width, height: parentSize.height - 60 }} />
      </TabPanel>
      <TabPanel value={tabSelected} index={1} >
        <ProductionAlloys productionData={productionData} parentSize={{ width: parentSize.width, height: parentSize.height - 60 }}/>
      </TabPanel>
      <TabPanel value={tabSelected} index={2} >
        <ProductionAlloysKPI productionData={productionData} parentSize={{ width: parentSize.width, height: parentSize.height - 60 }}/>
      </TabPanel>
      <TabPanel value={tabSelected} index={3} >
        <ProductionLime productionData={productionData} parentSize={{ width: parentSize.width, height: parentSize.height - 60 }}/>
      </TabPanel>
      <TabPanel value={tabSelected} index={4} >
        <ProductionLimeKPI productionData={productionData} parentSize={{ width: parentSize.width, height: parentSize.height - 60 }}/>
      </TabPanel>
    </>
  );
};


export default ProductionTab;